import React, { useCallback, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import {
    Avatar,
    Box,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    Paper,
} from "@material-ui/core";
import { Person, Visibility, VisibilityOff } from "@material-ui/icons";
import { getUserMe, loginSystem } from "../../../api/userApi";
import { swalCondition } from "../../../utils/swalHelper";
import Color from "../../../styles/Color";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { encode } from "../../../utils/crypt";

const initialValues = {
    email: "",
    password: "",
};

function Login(props) {
    const history = useHistory();
    const controllerRef = useRef(null);

    // component state
    const [loading, setLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);

    // formik schema
    const LoginSchema = Yup.object().shape({
        email: Yup.string()
            // .email("รูปแบบอีเมลไม่ถูกต้อง")
            .min(3, "ขั้นต่ำ 3 ตัวอักษร")
            .max(50, "สูงสุด 50 ตัวอักษร")
            .required("กรุณาระบุชื่อผู้ใช้งานหรืออีเมล"),
        password: Yup.string()
            .min(8, "ขั้นต่ำ 8 ตัวอักษร")
            .max(50, "สูงสุด 50 ตัวอักษร")
            .required("กรุณาระบุรหัสผ่าน"),
    });

    const setLocalStorage = useCallback(
        async (signal, accessToken) => {
            try {
                localStorage.setItem("authToken", JSON.stringify(accessToken));
                const data_user_me = await getUserMe(signal);
                localStorage.setItem("user", JSON.stringify(data_user_me?.user));
                localStorage.setItem("reload", 0);
                history.go(0);
            } catch (error) {
                console.dir(error);
            }
        },
        [history],
    );

    const enableLoading = () => {
        setLoading(true);
    };

    const disableLoading = () => {
        setLoading(false);
    };

    const getInputClasses = fieldname => {
        if (formik.touched[fieldname] && formik.errors[fieldname]) {
            return "is-invalid";
        }

        if (formik.touched[fieldname] && !formik.errors[fieldname]) {
            return "is-valid";
        }

        return "";
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        enableLoading();
        try {
            const encodedPassword = await encode(values?.password);
            loginSystem(values?.email, encodedPassword, controllerRef.current?.signal)
                .then(async ({ access_token }) => {
                    await setLocalStorage(controllerRef.current?.signal, access_token);
                })
                .catch(() => {
                    swalCondition("ผิดพลาด!", "ไม่พบข้อมูลในระบบ", { icon: "error", confirmButtonText: "OK", showCancelButton: false });
                });
        } catch (error) {
            console.dir(error);
        } finally {
            disableLoading();
            setSubmitting(false);
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema: LoginSchema,
        onSubmit: handleSubmit,
    });

    useEffect(() => {
        controllerRef.current = new AbortController();
        return () => {
            controllerRef.current.abort();
        };
    }, []);

    return (
        <div className="d-flex flex-column flex-root">
            {/*begin::Login*/}
            <div
                className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
                id="kt_login"
                style={{
                    backgroundImage: `linear-gradient(to right, #ffffff, #e4f5fd, #ade0f9)`,
                }}>
                {/*begin::Content*/}
                <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
                    {/* begin::Content body */}
                    <div className="h-100">
                        <Box className="h-100">
                            <Grid container className="h-100">
                                <Grid item xs={12} md={6} className="d-flex align-items-center">
                                    <Grid container justify="center">
                                        <Grid item xs={8} sm={4} md={4} lg={5}>
                                            <div className="mb-lg-10 d-flex justify-content-center">
                                                <img
                                                    src={toAbsoluteUrl("/media/logos/portal/logo-big.png")}
                                                    className="img-fluid rounded-top w-75 mx-auto"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="d-none d-lg-block">
                                                <img
                                                    src={toAbsoluteUrl("/media/logos/portal/logo-cap.png")}
                                                    className="img-fluid rounded-top"
                                                    alt=""
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6} className="d-flex align-items-center">
                                    <Grid container justify={"center"}>
                                        <Grid item xs={12} md={8}>
                                            <Paper className="d-flex justify-content-center py-5 pt-10 position-relative">
                                                <Box
                                                    className="position-absolute d-flex justify-content-center w-100"
                                                    style={{ top: "-3em" }}>
                                                    <div
                                                        className="box-icon-login d-flex justify-content-center align-items-center"
                                                        style={{
                                                            width: 70,
                                                            height: 70,
                                                            borderRadius: "50%",
                                                            background: "rgba(0, 120, 240, 0.15)",
                                                        }}>
                                                        <Person style={{ color: Color.primary, fontSize: 36 }} />
                                                    </div>
                                                </Box>
                                                <div className="login-form login-signin" id="kt_login_signin_form">
                                                    {/* begin::Head */}
                                                    <div className="text-center mb-10 mb-lg-20 mt-10 mt-lg-20">
                                                        <h3 className="font-size-h1" style={{ color: Color.primary }}>
                                                            Login Account
                                                        </h3>
                                                        {/* <h3 className="font-size-h1">
                                                <FormattedMessage id="AUTH.LOGIN.TITLE" />
                                            </h3> */}
                                                    </div>
                                                    {/* end::Head */}

                                                    {/*begin::Form*/}
                                                    <form
                                                        onSubmit={formik.handleSubmit}
                                                        className="form fv-plugins-bootstrap fv-plugins-framework">
                                                        <Grid container justify="center">
                                                            <Grid item xs={10} md={8}>
                                                                <FormControl
                                                                    fullWidth
                                                                    variant="standard"
                                                                    className="t-form-group-custom mb-10">
                                                                    <InputLabel htmlFor="standard-adornment-password">
                                                                        Username
                                                                    </InputLabel>
                                                                    <Input
                                                                        id="standard-adornment-password"
                                                                        type="text"
                                                                        {...formik.getFieldProps("email")}
                                                                        className={`w-100 ${getInputClasses("email")}`}
                                                                        endAdornment={
                                                                            <InputAdornment position="end">
                                                                                <Avatar
                                                                                    style={{
                                                                                        background: "none",
                                                                                        color: "inherit",
                                                                                    }}>
                                                                                    <Person />
                                                                                </Avatar>
                                                                            </InputAdornment>
                                                                        }
                                                                    />
                                                                    {formik.touched.email && formik.errors.email ? (
                                                                        <div className="fv-plugins-message-container">
                                                                            <div className="fv-help-block">
                                                                                {formik.errors?.email}
                                                                            </div>
                                                                        </div>
                                                                    ) : null}
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item xs={10} md={8}>
                                                                <FormControl
                                                                    fullWidth
                                                                    variant="standard"
                                                                    className="t-form-group-custom mb-10">
                                                                    <InputLabel htmlFor="standard-adornment-password">
                                                                        Password
                                                                    </InputLabel>
                                                                    <Input
                                                                        id="standard-adornment-password"
                                                                        type={showPass ? "text" : "password"}
                                                                        {...formik.getFieldProps("password")}
                                                                        className={`w-100 ${getInputClasses(
                                                                            "password",
                                                                        )}`}
                                                                        endAdornment={
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    aria-label="toggle password visibility"
                                                                                    onClick={() =>
                                                                                        setShowPass(!showPass)
                                                                                    }>
                                                                                    {showPass ? (
                                                                                        <VisibilityOff />
                                                                                    ) : (
                                                                                        <Visibility />
                                                                                    )}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        }
                                                                    />
                                                                    {formik.touched.password &&
                                                                    formik.errors.password ? (
                                                                        <div className="fv-plugins-message-container">
                                                                            <div className="fv-help-block">
                                                                                {formik.errors.password}
                                                                            </div>
                                                                        </div>
                                                                    ) : null}
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item xs={10} md={8}>
                                                                <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                                                                    <button
                                                                        id="kt_login_signin_submit"
                                                                        type="submit"
                                                                        disabled={formik.isSubmitting}
                                                                        className="btn btn-lg btn-block"
                                                                        style={{
                                                                            backgroundColor: Color.primary,
                                                                            color: "#FFFFFF",
                                                                            borderRadius: 150,
                                                                        }}>
                                                                        <span>เข้าสู่ระบบ</span>
                                                                        {loading && (
                                                                            <span className="ml-3 spinner spinner-white"></span>
                                                                        )}
                                                                    </button>
                                                                    {/* <div className="w-100 d-flex justify-content-center justify-content-lg-end mt-5">
                                                                        <ButtonBase
                                                                            className=""
                                                                            onClick={() => {
                                                                                history.push("/auth/forgot-password");
                                                                            }}
                                                                            style={{ color: "#797979" }}>
                                                                            Forget to password.
                                                                        </ButtonBase>
                                                                    </div> */}
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </form>
                                                    {/*end::Form*/}
                                                </div>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </div>
                    {/*end::Content body*/}
                </div>
                {/*end::Content*/}
            </div>
            {/*end::Login*/}
        </div>
    );
}

export default Login;
// export default injectIntl(connect(null, auth.actions)(Login));
